import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';

const WarehouseSelector = ({ selectedWarehouseId, warehouses, handleChange }) => {
    const onChange = (value) => {
        handleChange(value);
    };

    const labelId = 'warehouse-selector-label';
    const selectId = 'warehouse-selector';

    return (
        <FormControl
            variant="standard"
            fullWidth
            sx={{
                marginTop: (theme) => theme.spacing(2),
                marginLeft: (theme) => theme.spacing(1),
                marginRight: (theme) => theme.spacing(1),
                width: '95%',
            }}>
            {/* Link label to native select via htmlFor so it lines up correctly */}
            <InputLabel htmlFor={selectId} id={labelId} shrink>
                Tilaus varastoon
            </InputLabel>
            <NativeSelect
                id={selectId}
                name={selectId}
                required={false}
                value={selectedWarehouseId}
                onChange={(evt) => onChange(evt.target.value)}
                inputProps={{ id: selectId }}
                sx={{ mt: 0.5 }}>
                <option value="">-Valitse-</option>

                {warehouses.map((v) => (
                    <option key={v.id} value={v.id}>
                        {v.name}
                    </option>
                ))}
            </NativeSelect>
        </FormControl>
    );
};

export default WarehouseSelector;
